import { call, options, params } from './helpers';

// Get all reservations for the organization
export const getReservations = (payload) =>
	call(`/v2/reservations${params(payload)}`);

// Get a specific reservation by ID
export const getReservation = ({ id }) => call(`/v2/reservations/${id}`);

// Get reservations for a specific user
export const getUserReservations = ({ userId, ...payload }) =>
	call(`/v2/reservations/user/${userId}${params(payload)}`);

// Get reservations for a specific asset
export const getAssetReservations = ({ assetId, ...payload }) =>
	call(`/v2/reservations/asset/${assetId}${params(payload)}`);

// Create a new reservation
export const createReservation = (payload) =>
	call(`/v2/reservations/create`, options(payload, 'POST'));

// Update an existing reservation
export const updateReservation = ({ id, ...payload }) =>
	call(`/v2/reservations/${id}`, options(payload, 'PUT'));

// Delete a reservation
export const deleteReservation = ({ id }) =>
	call(`/v2/reservations/${id}`, options(null, 'DELETE'));

// Remove a single asset from a reservation
export const removeAssetFromReservation = ({ reservationId, assetId }) =>
	call(`/v2/reservations/${reservationId}/asset/${assetId}`, options(null, 'DELETE'));

// Verify availability of assets for a time range
export const verifyAvailability = (payload) =>
	call(`/v2/reservations/verify`, options(payload, 'POST'));

// Confirm a reservation
export const confirmReservation = ({ id }) =>
	call(`/v2/reservations/${id}/confirm`, options(null, 'PATCH'));

// Get reservation categories
export const getReservationCategories = () =>
	call(`/v2/reservations/categories/all`);

// Create a new reservation category
export const createReservationCategory = (payload) =>
	call(`/v2/reservations/categories/create`, options(payload, 'POST'));
